// One look for every farm store page: warm off-white ground, near-black ink,
// one green accent, a serif for headings and a plain sans for everything
// else. Components read STORE for the few values MUI's theme can't carry.
import { createTheme } from "@mui/material/styles";

export const STORE = {
  bg: "#FBFAF6",
  bgAlt: "#F4F1EA",
  surface: "#FFFFFF",
  ink: "#1A1A1A",
  body: "#4A4A45",
  muted: "#5B5547",
  faint: "#8A8478",
  line: "#E6E2D8",
  accent: "#1E6B3F",
  accentDark: "#175432",
  accentTint: "#E7F1EA",
  placeholder: "#E8E1CF",
  fontDisplay: "'Fraunces', Georgia, serif",
  fontBody: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  radius: 18,
  radiusSm: 12,
  maxWidth: 1200,
};

// Page gutters: the same container on every section
export const container = {
  width: "100%",
  maxWidth: STORE.maxWidth,
  mx: "auto",
  px: { xs: 2.5, md: 4 },
  boxSizing: "border-box",
};

export const sectionTitle = {
  fontFamily: STORE.fontDisplay,
  fontWeight: 500,
  letterSpacing: "-0.01em",
  color: STORE.ink,
  lineHeight: 1.1,
  fontSize: { xs: 28, md: 40 },
  m: 0,
};

export const pillButton = {
  height: 52,
  px: 3.5,
  borderRadius: 999,
  fontSize: 16,
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { boxShadow: "none" },
};

export const storeTheme = createTheme({
  palette: {
    primary: { main: STORE.accent, dark: STORE.accentDark, contrastText: "#FFFFFF" },
    secondary: { main: STORE.ink },
    background: { default: STORE.bg, paper: STORE.surface },
    text: { primary: STORE.ink, secondary: STORE.muted },
    divider: STORE.line,
  },
  shape: { borderRadius: STORE.radiusSm },
  typography: {
    fontFamily: STORE.fontBody,
    h1: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    h2: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    h3: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    h4: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    h5: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    h6: { fontFamily: STORE.fontDisplay, fontWeight: 500 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, paddingLeft: 20, paddingRight: 20, minHeight: 44 },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: STORE.radiusSm, backgroundColor: STORE.surface },
        notchedOutline: { borderColor: STORE.line },
      },
    },
    MuiIconButton: {
      styleOverrides: { root: { color: STORE.ink } },
    },
  },
});
